import Block from './block';
import { getChildren } from '../../registry';

export default {
	component: Block,
	getChildren(props) {
		return getChildren({ ...props, type: props.baseType });
	},
};
